const NAME = 'USER';

export const userProfile = (store) => store[NAME].profile.data || {};
export const getUsers = (store) => store[NAME].list.data || [];
export const getPaginatedUsers = (store) => store[NAME].list.allData || [];
export const usersPageMeta = (store) => store[NAME].list.page || {};
export const userData = (store) => store[NAME].show.data || {};
